module.exports = __webpack_public_path__ + "img/spgl.89d92a3c.svg";